import { render, staticRenderFns } from "./FollowUpList.vue?vue&type=template&id=46d8f440&"
import script from "./FollowUpList.vue?vue&type=script&lang=js&"
export * from "./FollowUpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports